// import config from '../../config'
// import window from 'global'
import axios from 'axios'
import moment from 'moment'
import { Toast } from 'antd-mobile'
import { actions } from '@src/mirrorx'
import { isPC } from 'zati-ui-web/lib/utils'

const deployEnv = process.env.DEPLOY_ENV
const assetsPrefix = `https://${deployEnv !== 'prd' ? 'testcdn.zaticdn.com' : 'cdn.zaticdn.com'}/life/za-life-portal-web/${deployEnv === 'local' ? 'dev' : deployEnv}/static`

const cookie = {
  get: function (name) {
    if (!global.document || !name) {
      return ''
    }
    let cookie = (global.document && global.document.cookie) || ''
    const reg = new RegExp('(^|(;\\s*))' + name + '=[^;]+', 'gi')
    let value = (cookie.match(reg) || [])[0] || ''
    value = value.replace(/[\s;]*/gi, '').split('=')[1] || ''

    return decodeURIComponent(value)
  },
  set: function (name, value, param) {
    if (!global.document) {
      return
    }
    let text = encodeURIComponent(name) + '=' + encodeURIComponent(value)
    param = param || {}
    param.path = param.path || '/'
    param.domain = param.domain || ('.' + window.location.hostname.split('.').slice(-2).join('.'))
    let expires = param.expires
    if (expires instanceof Date) {
      text += ';expires=' + expires.toGMTString()
    } else if (typeof expires === 'number') {
      let now = new Date()
      let time = now.getTime()
      let expireTime = time + expires * 1000
      now.setTime(expireTime)
      text += ';expires=' + now.toGMTString()
    }
    if (param.path) {
      text += ';path=' + param.path
    }
    if (param.domain) {
      text += ';domain=' + param.domain
    }
    if (param.secure) {
      text += ';secure'
    }
    global.document.cookie = text
  },
  unset: function (name, path, domain, secure) {
    this.set(name, '', new Date(0), path, domain, secure)
  }
}

const localStorage = {
  set(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    }
    global.localStorage && global.localStorage.setItem(key, value)
  },
  get(key, value) {
    return global.localStorage && global.localStorage.getItem(key)
  },
  remove(key, value) {
    global.localStorage && global.localStorage.removeItem(key)
  },
  clear() {
    global.localStorage && global.localStorage.clear()
  }
}

const loading = {
  show: () => {

  },
  hide: () => {

  }
}

// if (typeof window === 'undefined') {
//   global.window = {
//     location: {},
//     navigator: {},
//     localStorage: {}
//   }
// }

function getCurrentLang() {
  const match = (typeof window !== 'undefined' ? window.location.pathname : '/hk').split('/')
  const langMap = {
    hk: 'zh_HK',
    en: 'en_US'
  }
  return langMap[match[1] || 'hk']
  // return i18n.language || 'zh_HK'
}

function getPrePath() {
  // const match = window.location.pathname.match(/^\/(\w+)(\/|\b)/)
  if (typeof window !== 'undefined') {
    const match = window.location.pathname.split('/')
    return `/${match[1]}`
  }
  return '/hk'
}

function setCurrentLang(lang) {
  let today = new Date()
  today.setFullYear(today.getFullYear() + 10)
  cookie.set('defaultLang', lang, { expires: today })
}


function isArray(obj) {
  return Object.prototype.toString.apply(obj) === '[object Array]'
}

function isObject(obj) {
  return Object.prototype.toString.apply(obj) === '[object Object]'
}

function getScreenHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
}

function getDeviceType() {
  const u = navigator.userAgent
  // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  if (isiOS) return 'ios'
  return 'android'
}

function urlQuery(key, url) {
  if (!process.browser) {
    return
  }
  const parseUrl = url || window.location.href
  let reg = new RegExp('[?&#]' + key + '=([^&#]*)', 'i')
  let match = parseUrl.match(reg)
  let result

  if (match) {
    try {
      result = decodeURIComponent(match[1]) || ''
      return result
    } catch (e) {
    }
  }
  return ''
}

function getEnv() {
  return process.env.DEPLOY_ENV || 'prd'
}

function getPageEnv() {
  let host = global.location && global.location.hostname
  if (/.*local.*\..*\.com$/.test(host)) {
    return 'local'
  }
  if (/za-tech.net$/.test(host) || /dev[-]*\w*.zatech.com/.test(host) || /.*dev.*\..*\.com$/.test(host)) {
    return 'dev'
  }
  if (/.*sit.*\..*\.com$/.test(host)) {
    return 'sit'
  }
  if (/.*uat.*\..*\.com$/.test(host)) {
    return 'uat'
  }
  if (/.*stg.*\..*\.com$/.test(host)) {
    return 'stg'
  }
  if (/(.*prd.*\.zatech\.com|.*za\.group.*)$/.test(host)) {
    return 'prd'
  }
  return 'prd'
}

function getSdkConfig() {
  let performanceConfig = {}
  let dev = 'prd'
  const host = global.location && global.location.hostname
  if (/local.zatech.com/.test(host)) {
    dev = 'dev'
  }
  if (/za-tech.net$/.test(host) || /dev[-]*\\w*.zatech.com/.test(host) || /dev.zatech.com/.test(host)) {
    dev = 'dev'
  }
  if (/.*sit.*\\.zatech\\.com$/.test(host)) {
    dev = 'sit'
  }
  if (/.*uat.*\\.zatech\\.com$/.test(host)) {
    dev = 'uat'
  }
  if (/.*stg.*\\.zatech\\.com$/.test(host)) {
    dev = 'stg'
  }
  if (/(.*prd.*\\.zatech\\.com|.*za\\.group.*)$/.test(host)) {
    dev = 'prd'
  }
  switch (dev) {
    case 'dev':
      performanceConfig = {
        appId: 'KSw5ZJE1599731148982',
        domain: 'https://zaneperfor-uat.zatech.com/api/v1/report/web'
      }
      break
    case 'sit':
      performanceConfig = {
        appId: 'JpBJCkX1599633622563',
        domain: 'https://zaneperfor-uat.zatech.com/api/v1/report/web'
      }
      break
    case 'uat':
      performanceConfig = {
        appId: 'tppeAHa1600063974038',
        domain: 'https://zaneperfor-uat.zatech.com/api/v1/report/web'
      }
      break
    case 'stg':
      performanceConfig = {
        appId: 'eEGA7MZ1603882785138',
        domain: 'https://wms.za.group/api/v1/report/web'
      }
      break
    case 'prd':
      performanceConfig = {
        appId: 'sc4RFBT1598532060539',
        domain: 'https://wms.za.group/api/v1/report/web'
      }
      break
  }
  return performanceConfig
}

function ajax(opt) {
  let url = `/ajax/${opt.url.replace(/^\//, '')}`
  // const headers = Object.assign({}, opt.headers, {
  //   language: i18n.language
  // })

  // // en zh ca
  // const langMap = {
  //   zh_HK: 'ca',
  //   en_US: 'en'
  // }
  const headers = { ...opt.headers }
  headers.lang = getCurrentLang()
  // const headers = { language: langMap[i18n.language], ...opt.headers }

  if (opt.method === 'get' || opt.method === 'GET') {
    const dataKeys = Object.keys(opt.data)
    if (dataKeys.length > 0) {
      const paramsArray = dataKeys.map((key) => {
        return `${key}=${opt.data[key]}`
      })

      url += `?${paramsArray.join('&')}`
    }
    opt.data = {}
  }

  let param = {
    method: opt.method || 'post',
    withCredentials: true,
    url: url,
    data: opt.data,
    timeout: 20e3,
    headers
  }
  if (opt.loading) {
    loading.show()
  }

  return new Promise(function (resolve, reject) {
    axios(param).then((result) => {
      const data = result.data || {}
      data.msg = data.msg || data.errorMsg
      if (!data.success && !opt.notip) {
        // T.showError(data.msg)
      }
      resolve(data)
    }).catch(function (error) {
      reject && reject(error)
      if (opt.loading) {
        loading.hide()
      }
      console.error(error)
    })
  })
}

// 有蒙版时阻止滚动
function stopBodyScroll(isFixed) {
  const bodyElement = document.body
  let top = 0
  if (isFixed) {
    top = window.scrollY
    bodyElement.style.overflow = 'hidden'
    bodyElement.style.position = 'fixed'
    bodyElement.style.top = -top + 'px'
  } else {
    bodyElement.style.position = ''
    bodyElement.style.top = ''
    bodyElement.style.overflow = 'auto'
    window.scrollTo(0, top)
  }
}

function getUuid() {
  const id = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })

  return id
}

function getAppUrl() {
  return {
    android: 'https://za.onelink.me/Lq9l?pid=ZaBank&c=Download_landing_page_1007659&link=jump%3Fmodule%3Dflutter%26type%3DmainPage%26content%3D%7B%22tabName%22%3A%22HomeTab%22%7D%26channel%3DchannelDid%3D88888%26utm_source%3DZaBank%26utm_medium%3DLink%26utm_campaign%3DDownload_landing_page_1007659',
    ios: 'https://za.onelink.me/Lq9l?pid=ZaBank&c=Download_landing_page_1007659&link=jump%3Fmodule%3Dflutter%26type%3DmainPage%26content%3D%7B%22tabName%22%3A%22HomeTab%22%7D%26channel%3DchannelDid%3D88888%26utm_source%3DZaBank%26utm_medium%3DLink%26utm_campaign%3DDownload_landing_page_1007659'
  }
}

function amountFormat(amount) {
  return amount.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
}

function loadLink(src, callback) {
  if (!src) {
    return
  }
  let node = document.createElement('link')
  node.rel = 'stylesheet'
  node.href = src
  let head = document.getElementsByTagName('head')[0]
  head.appendChild(node)
  if (callback) {
    node.onload = callback
  }
}

function gtag() {
  window.dataLayer = window.dataLayer || []
  if (process.env.DEPLOY_ENV === 'prd' || urlQuery('mode') === 'test') { // 在生产环境才统计
    window.dataLayer.push(arguments)
  }
}

function gtagGTM(data) {
  window.dataLayer = window.dataLayer || []
  if (process.env.DEPLOY_ENV === 'prd' || urlQuery('mode') === 'test') { // 在生产环境才统计
    window.dataLayer.push(data)
  }
}

// const scriptAppended = []
function loadScript(src, callback, id = '') {
  if (!src) { // || scriptAppended.includes(src)
    return false
  }
  let node = document.createElement('script')
  node.type = 'text/javascript'
  node.async = true
  node.src = src
  node.id = id
  let head = document.getElementsByTagName('head')[0]
  head.appendChild(node)
  // scriptAppended.push(src)
  if (callback) {
    node.onload = callback
  }
  return true
}

let gtmloaded = false
function loadGTM() {
  !gtmloaded && (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(),
      event: 'gtm.js'
    }); let f = d.getElementsByTagName(s)[0]

    let j = d.createElement(s); let dl = l !== 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f)

    gtmloaded = true
  })(window, document, 'script', 'dataLayer', 'GTM-TFF2MX8')
}

function isFacebook() {
  if (document.referrer && document.referrer !== '') {
    return document.referrer.toLowerCase().includes('facebook')
  } else {
    return false
  }
}

// onelink
function generateOnelink(type = 'loan') {
  const env = getEnv()
  const isProd = env === 'prd'
  let downloadUrl = isProd ? 'https://za.onelink.me/Lq9l' : 'https://zatest.onelink.me/cSDy'

  const utmSource = urlQuery('utm_source') || 'ZaBank'
  const utmMedium = urlQuery('utm_medium') || 'Link'
  const utmCampaign = urlQuery('utm_campaign') || (type === 'loan' ? 'Downlaod_loan_1007728' : 'Downlaod_deposit_1007657')

  const link = encodeURIComponent('jump?module=flutter&type=mainPage&content={"tabName":"LoanTab"}')
  const channel = encodeURIComponent(`&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`)
  const channelQuery = `link=${link}&channel=${channel}`

  let partnerIDParam = 'pid='
  let pidValue
  if (urlQuery('pid')) {
    pidValue = urlQuery('pid')
  } else {
    pidValue = utmSource
  }
  let campaignValue = utmCampaign
  if (urlQuery('c')) {
    campaignValue = urlQuery('c')
  }
  let campaignParam = 'c='
  let gclidParam = 'af_sub1='
  const gclidValue = urlQuery('gclid')
  let kwParam = 'af_keywords='
  const kwValue = urlQuery('keyword')

  // Prevent the use of real SRN names. Remove this part after you are done testing the scrip
  // const SRNs = [
  //   'twitter_int',
  //   'facebook_int',
  //   'snapchat_int',
  //   'doubleclick_int',
  //   'yahoogemini_int',
  //   'yahoojapan_int'
  // ]

  const isDebug = false
  if (pidValue) {
    campaignParam += campaignValue
    partnerIDParam += pidValue
    // finalURL = oneLinkURL + partnerIDParam + campaignParam
    downloadUrl = `${downloadUrl}?${partnerIDParam}&${campaignParam}&${channelQuery}`
    if (isDebug) {
      console.info('This user comes the SRN or custom network ' + pidValue + '\n' + downloadUrl)
    }
  } else if (gclidValue) {
    // Google Ads
    partnerIDParam += 'google_lp'
    campaignParam += campaignValue
    gclidParam += gclidValue
    if (!kwValue) {
      // finalURL = oneLinkURL + partnerIDParam + campaignParam + gclidParam
      downloadUrl = `${downloadUrl}?${partnerIDParam}&${campaignParam}&${gclidParam}&${channelQuery}`
      if (isDebug) {
        console.info('This user comes from Google AdWords\n ' + downloadUrl)
      }
    } else { // Google Ads with KW
      kwParam += kwValue
      // finalURL = oneLinkURL + partnerIDParam + campaignParam + gclidParam + kwParam
      downloadUrl = `${downloadUrl}?${partnerIDParam}&${campaignParam}&${gclidParam}&${kwParam}&${channelQuery}`
      if (isDebug) {
        console.info('This user comes from Google AdWords - there is a keyword associated with the ad\n ' + downloadUrl)
      }
    }
    // Other SRNs and custom networks
  } else if (isFacebook()) {
    if (isDebug) {
      console.info("This user comes from a paid Facebook ad - don't do anything. \nKeep direct app store links.")
    }
  } else { // organic mobile user
    if (isDebug) {
      console.info("This user comes from an unknown mobile source.\n The user would be attributed to media source 'website' and to the campaign " + campaignParam + '\n' + downloadUrl)
    }
  }

  // if (SRNs.includes(pidValue)) {
  //   if (isDebug) {
  //     console.info('DO NOT USE NAMES OF SRNS IN af_pid or utm_source - use the names listed in Other SRNs: Add Parameter section in the landing page article\nhttps://supporappsflyer.com/hc/en-us/articles/360000677217#other-srns-add-parameter')
  //   }
  //   downloadUrl = `${downloadUrl}?${channelQuery}`
  // }
  //
  // if (isAFLink()) {
  //   if (isDebug) {
  //     console.info('This user comes from AppsFlyer by redirection and is ready to be attributed. \nKeep direct app store links.')
  //   }
  //   downloadUrl = `${downloadUrl}?${channelQuery}`
  // }

  return downloadUrl
}

// 判断是否是真实手机
function isMobilePhone() {
  let isMobile = navigator.platform.indexOf('Mac') === navigator.platform.indexOf('Win')
  if (navigator.maxTouchPoints) {
    isMobile = isMobile && navigator.maxTouchPoints > 2
  }
  return isMobile
}

function debounce(func, delay) {
  // 防抖函数，用于提交按钮的点击事件、input输入框架的格式验证等限制点击次数的事件
  let timeout
  return function (e) {
    clearTimeout(timeout)
    const context = this
    const args = arguments
    timeout = setTimeout(function () {
      func.apply(context, args)
    }, delay)
  }
}

function throttle(fn, threshhold1) {
  // 节流函数，用在比input, keyup更频繁触发的事件中，如resize, touchmove, mousemove, scroll.会强制函数以固定的速率执行
  let timeout
  let start = new Date()
  const threshhold = threshhold1 || 160
  return function () {
    const context = this
    const args = arguments
    const curr = new Date() - 0

    clearTimeout(timeout)
    if (curr - start >= threshhold) {
      fn.apply(context, args)
      start = curr
    } else {
      timeout = setTimeout(function () {
        fn.apply(context, args)
      }, threshhold)
    }
  }
}

function getAttrObject(objArray, key, value) { // 一个对象数组，获取key等于value的对象数组
  objArray = (objArray instanceof Array) ? objArray : [objArray]
  let arr = []
  let item
  let temp
  for (let i = 0; i < objArray.length; i++) {
    item = objArray[i]
    if (item === undefined) {
      continue
    }
    temp = (key instanceof Array) ? item[key[0]][key[1]] : item[key]

    if (value instanceof Array) {
      if (value.indexOf(temp) > -1) {
        arr.push(item)
      }
    } else {
      if (String(temp) === String(value)) { // 此处不要改为全等
        arr.push(item)
      }
    }
  }

  return arr
}

function getAge(date) {
  if (!date) {
    return
  }
  const birthday = date && moment(date).format('YYYY-MM-DD').split('-')
  const now = moment().format('YYYY-MM-DD').split('-')
  let age = null
  const [year, month, day] = birthday
  const [nowYear, nowMonth, nowDay] = now

  if (nowYear === year) {
    age = 0 // 同年 则为 0岁
  } else {
    const yearDiffer = nowYear - year // 年相差
    if (yearDiffer > 0) {
      if (nowMonth === month) { // 年月相同的情况比较日
        const dayDiffer = nowDay - day
        if (dayDiffer < 0) {
          age = yearDiffer - 1
        } else {
          age = yearDiffer
        }
      } else { // 月不相同的情况直接比较月
        const monthDiffer = nowMonth - month
        if (monthDiffer < 0) {
          age = yearDiffer - 1
        } else {
          age = yearDiffer
        }
      }
    } else {
      age = -1 // 表示出生年月大于今年
    }
  }
  return age // 返回周岁年龄
}

const sessionStorage = {
  set(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    }
    global.sessionStorage && global.sessionStorage.setItem(key, value)
  },
  get(key, value) {
    return global.sessionStorage && global.sessionStorage.getItem(key)
  },
  remove(key, value) {
    global.sessionStorage && global.sessionStorage.removeItem(key)
  },
  clear() {
    global.sessionStorage && global.sessionStorage.clear()
  }
}

// 通过年龄获取当前是日期
function getDate(age) {
  const now = moment().format('YYYY-MM-DD').split('-')
  let birthday = null
  let [nowYear, nowMonth, nowDay] = now
  if (nowYear - age === Number(nowYear)) {
    if (nowMonth === '01') {
      nowMonth = '12'
      nowYear--
    } else if (nowMonth <= 10) {
      nowMonth = '0' + (nowMonth - 1)
    } else {
      nowMonth--
    }
  }
  birthday = [nowYear - age, nowMonth, nowDay].join('-')
  return birthday
}

function jump(path, openBlank = false) {
  if (!/^http(s)?:\/\//.test(path)) {
    path = getPrePath() + '/' + path.replace(/^\/+/, '')
  }
  if (openBlank) {
    window.open(path)
  } else {
    window.location.href = path
  }
}

function formatPrice(num, int) {
  // console.log(num)
  if (num === undefined) {
    return ''
  }
  if (int) {
    num = parseInt(num)
  }
  num = String(num)
  num = num.replace(/(\d+\.\d{2})\d+/, '$1')
  num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return num
}

function formatDate(format, date) { //   "yyyy-MM-dd hh:mm:ss"
  if (!date || !format) {
    return ''
  }
  if (typeof date === 'string') {
    date = date.replace(/-/g, '/')
  }
  date = new Date(date)
  let o = {
    'M+': date.getMonth() + 1, // month
    'd+': date.getDate(), // day
    'h+': date.getHours(), // hour
    'm+': date.getMinutes(), // minute
    's+': date.getSeconds(), // second
    'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
    S: date.getMilliseconds(), // millisecond
    w: '日一二三四五六'.charAt(date.getDay())
  }
  format = format.replace(/y{4}/i, date.getFullYear())
    .replace(/y{2}/i, date.getFullYear().toString().substring(2))

  for (var k in o) {
    let reg = new RegExp(k)
    format = format.replace(reg, match)
  }
  function match(m) {
    return m.length === 1 ? o[k] : ('00' + o[k]).substr((String(o[k])).length)
  }
  return format
}

function checkEmail(email = '') {
  const index = email.indexOf('@')
  const index2 = email.indexOf('.')
  if (index <= 0 || index === email.length - 1) {
    return false
  }
  if (index2 <= 0 || index2 === email.length - 1) {
    return false
  }
  return true
  // return /^(?:[\w-]+\.?)*[\w-]+@(?:\w+\.)+\w+$/.test(email)
}

function transDateFormatDDMMYYYY(str) {
  if (str) {
    return str.replace(/(\d{4})[-/](\d{2})[-/](\d{2}).*/, '$3-$2-$1')
  }
}

function transDateFormatYYYYMMDD(str) {
  if (str) {
    return str.replace(/(\d{2})[-/](\d{2})[-/](\d{4}).*/, '$3-$2-$1')
  }
}

function getAgeRange(blocksMap, goodsId) {
  const getRange = (type) => {
    // let { blocksMap } = getState().onlineApplicationModel
    const obj = getAttrObject(blocksMap[type] || [], 'customizeCode', 'birthday')[0] || {}
    let { minValue, maxValue } = obj.show || {}
    minValue = minValue + ' 00:00:00'
    maxValue = maxValue + ' 00:00:00'
    minValue = minValue.replace(/-/g, '/')
    maxValue = maxValue.replace(/-/g, '/')
    return [new Date(minValue).getTime(), new Date(maxValue).getTime()]
  }
  const [holderMinValue, holderMaxValue] = getRange(1)
  const [insurantMinValue, insurantMaxValue] = getRange(2)
  // let goodsId = T.urlQuery('goodsId')
  if (Number(goodsId) === 253005) {
    return getRange(1)
  } else {
    return [holderMinValue < insurantMinValue ? insurantMinValue : holderMinValue,
    holderMaxValue > insurantMaxValue ? holderMaxValue : insurantMaxValue
    ]
  }
}

// 模板引擎,主要是为了处理国际化时多个变量
function template(str = '', replaceMap = {}) {
  // /(?<={)[^}]+(?=})/g  有些不支持 <的语法
  const array = str.match(/(?={)[^}]+}/g) || []
  if (!str || Object.prototype.toString.call(replaceMap) !== '[object Object]') {
    return str
  }
  array.forEach((item) => {
    const key = item.replace('{', '').replace('}', '').replace(/\s+/, '')
    if (replaceMap && replaceMap[key]) {
      str = str.replace(item, replaceMap[key])
    }
  })
  return str
}

function showError(msg, time) {
  if (msg) {
    if (typeof msg === 'object') {
      msg = JSON.stringify(msg)
    }
    Toast.info(msg, time)
  }
}

function getCurrentPath() {
  const replacePath = _path => {
    if (_path === '' || _path === '/') return '/'
    return _path.replace(/\/$/, '')
  }
  const pathnameWithoutLocale = typeof window !== 'undefined' ? window.location.pathname.replace(getPrePath(), '') : '/'
  return replacePath(pathnameWithoutLocale)
}

function htmlDecode(str) {
  if (typeof str !== 'string') return ''
  str = str.replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '\'')
    .replace(/&nbsp;/g, ' ')
  return str
}

function getConfig() {
  const config = {
    local: {
      dunkeyHost: '139.159.196.155:8080',
      kfHost: 'zaip-aic-uat.zaintl.com'
    },
    dev: {
      dunkeyHost: '139.159.196.155:8080',
      kfHost: 'zaip-aic-uat.zaintl.com'
    },
    sit: {
      dunkeyHost: '139.159.196.155:8080',
      kfHost: 'zaip-aic-uat.zaintl.com'
    },
    uat: {
      dunkeyHost: 'anan-uat-af-skynet.zatech.com',
      kfHost: 'zaip-aic-uat.zaintl.com'
    },
    prd: {
      dunkeyHost: 'anan-prd-skynet.zatech.com',
      kfHost: 'zaip-aic.za.group'
    }
  }
  const env = getEnv()
  return config[env]
}

function showLoading() {
  if (get('loadingBox')) {
    setTimeout(() => {
      get('loadingBox').style.display = 'block'
    }, 0)
  }
}
function hideLoading() {
  if (get('loadingBox')) {
    get('loadingBox').style.display = 'none'
  }
}
function get(id) {
  if (!global.document) {
    return null
  }
  return global.document.getElementById(id)
}
const seoConfig = {
  en_US: {
    title: 'ZA Insure | Hong Kong Fully Digital Insurer',
    content: 'Merging insurance & technology, you can get insured within a few minutes and no medical checkup report is needed. Customized scenario based insurance to protect your every micro moment .',
    keywords: 'Zhongan, ZA Insurance, Insurance Comparison'
  },
  zh_HK: {
    title: 'ZA Insure | 香港全數碼化保險公司',
    content: '結合保險與科技，最快數分鐘完成投保，即時出單受保，無需驗身報告，自己配搭，自己話事',
    keywords: '眾安保險 保險 保險公司 保險比較'
  },
  253005: { // vhis
    en_US: {
      title: 'VHIS | ZA Life',
      content: 'Merging VHIS & technology, you can get insured within a few minutes and no medical checkup report is needed. Customized scenario based insurance to protect your every micro moment .',
      keywords: 'VHIS, Medical Insurance, Medical Insurance Comparison'
    },
    zh_HK: {
      title: '自願醫保計劃 | 眾安人壽ZA Life',
      content: '結合自願醫保與科技，最快數分鐘完成投保，即時出單受保，自己配搭，自己話事',
      keywords: '自願醫保 醫療保險 醫保扣稅 醫保比較'
    }
  },
  223030: { // cancer
    en_US: {
      title: ' ZA Cancer Protection | ZA Insure',
      content: 'Cancer Insurance with a price as low as $3 per month, coverage up to HK$10 million, age 100 and even with a family history of cancer.',
      keywords: 'Cancer insurance, cancer insurance policy, cancer insurance plan, critical illness insurance, critical illness insurance comparison, critical illness insurance rates'
    },
    zh_HK: {
      title: 'ZA 癌症保 | ZA Insure',
      content: '癌症保費低至每月$3，高達$1000萬保障，更可保至100歲，有癌症家族病史同樣受保',
      keywords: '癌症保險,  癌症保險比較, 癌症保險理賠, 危疾保險, 危疾保險比較'
    }
  },
  223017: { // HAS
    en_US: {
      title: 'ZA Heart Attack & Stroke Protection | ZA Insure',
      content: ' First heart attack & stroke insurance in Hong Kong,  price as low as $0.3 per month and can get insured within a few minutes.',
      keywords: 'Heart attack insurance, heart attack insurance claim, heart attack insurance policy, Stroke insurance, stroke insurance coverage, stroke insurance claims, Critical illness insurance, critical illness insurance comparison, critical illness insurance rates'
    },
    zh_HK: {
      title: 'ZA 心中保 | ZA Insure',
      content: '全港首創心臟病及中風保險，每月保費低至$0.3，最快幾分鐘即可完成投保',
      keywords: '心臟病保險, 中風保險, 心臟病保險理賠, 中風保險理賠, 危疾保險, 危疾保險比較'
    }
  },
  223035: { // life
    en_US: {
      title: 'ZA Life Protection | ZA Insure',
      content: 'Merging life insurance & technology, you can get insured within a few minutes and no medical checkup report is needed. Customized scenario based insurance to protect your every micro moment .',
      keywords: 'Life insurance, life insurance type'
    },
    zh_HK: {
      title: 'ZA 人壽保 | ZA Insure',
      content: '結合人壽保險與科技，最快幾分鐘完成投保，即時出單受保，無需驗身報告，自己配搭，自己話事',
      keywords: '人壽保險,人壽, 人壽保險比較, 人壽保'
    }
  },
  290001: { // life
    en_US: {
      title: 'ZA Accident Protection | ZA Insure',
      content: 'Equip yourself with accident protection',
      keywords: 'Accident Protection, Accident Protection type'
    },
    zh_HK: {
      title: 'ZA 意外保 | ZA Insure',
      content: '為你提供一個「意外護身符」',
      keywords: '意外保險,意外, 意外保險比較, 意外保'
    }
  }
}
function isPA(goodsId) {
  return Number(goodsId) === 290001
}

function isVHIS(goodsId) {
  return Number(goodsId) === 253005
}

function showLoginFromUrl(lifeUser, zafamUser) {
  const isLogin = lifeUser && lifeUser.isLogin
  const zafamIsLogin = zafamUser && zafamUser.isLogin
  if (urlQuery('showLogin') === '1' && (!isLogin || !zafamIsLogin)) { // 不能仅仅通过路径判断是否显示登录弹框，应该要判断下当前是否是登录态
    let toPageUrl = urlQuery('backUrl') || ''
    const backUrl = global.location.protocol + '//' + global.location.host + getPrePath() + toPageUrl
    actions.mainModel.setLoginBackUrl(backUrl)
    actions.mainModel.setShowLoginBox(true)
  }
}


// 将年龄转成日期
export const ageToDate = (age) => {
  if (!age) return;
  return getDate(age) + ' 00:00:00'
}

export function loadXman() {
  if (window['_XFLOW_']) return
  let id
  let src
  switch (getPageEnv()) {
    case 'sit':
    case 'uat':
      id = '00pzoutopnjr0vyn'
      src = `//zaip-uat.obs.ap-southeast-1.myhuaweicloud.com/static/sdk/dist/js/v0.0.1/ilog.js?id=${id}&setting=true`
      break
    case 'prd':
      id = 'jw4evhrwcyln3me0'
      src = `https://cdn.zaticdn.com/if/xman/static/sdk/dist/js/v0.0.1/ilog.js?id=${id}&setting=true&random=1`
      break
    default:
      src = ''
      break
  }
  try {
    loadScript(src, () => {
      const { XFlow } = window
      if (XFlow instanceof Function) {
        window['_XFLOW_'] = new XFlow({ input: true })
      }
    })
  } catch (err) { }

}

// Todo 补充注释
export {
  getCurrentLang,
  getPrePath, // 获取前缀
  isArray,
  isObject,
  getScreenHeight,
  getDeviceType,
  urlQuery,
  getEnv,
  cookie,
  loading,
  ajax,
  stopBodyScroll,
  isPC,
  getUuid,
  getAppUrl,
  amountFormat, // 金额格式化
  gtag,
  gtagGTM,
  loadScript,
  loadLink,
  loadGTM,
  generateOnelink,
  isMobilePhone,
  debounce,
  throttle,
  getAttrObject,
  getAge,
  sessionStorage,
  getDate,
  jump,
  formatPrice,
  formatDate,
  checkEmail,
  transDateFormatDDMMYYYY,
  transDateFormatYYYYMMDD,
  getAgeRange,
  template,
  showError,
  getCurrentPath,
  htmlDecode,
  getConfig,
  showLoading,
  hideLoading,
  get,
  seoConfig,
  assetsPrefix,
  isPA,
  getSdkConfig,
  getPageEnv,
  setCurrentLang,
  isVHIS,
  showLoginFromUrl,
  localStorage
}
